module.exports = __webpack_public_path__ + "6d169505e800385007b701a482669616.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MY.svg
// module id = rGw5
// module chunks = 0